import React, { memo, useEffect } from 'react';
import { useUpdate } from 'react-use';
export const Renderer = memo(({ storage }) => {
    const update = useUpdate();
    useEffect(() => {
        storage.on('update', update);
        return () => {
            storage.off('update', update);
        };
    }, [storage, update]);
    return (React.createElement(React.Fragment, null, storage.getItems().map((item) => (React.createElement(ItemRenderer, { key: item.id, item: item })))));
});
Renderer.displayName = 'ReactRenderer';
const ItemRenderer = memo(({ item }) => {
    const update = useUpdate();
    useEffect(() => {
        item.on('rerender', update);
        return () => {
            item.off('rerender', update);
        };
    }, [item, update]);
    return React.createElement(React.Fragment, null, item.render());
});
ItemRenderer.displayName = 'ReactItemRenderer';
